// General
import { gsap, Power4 } from 'gsap'

import { ready } from './lib/utils/utils'

// Stimulus.js and controllers
import { Application } from 'stimulus';
import registerGeneratedControllers from './generated/register-generated-controllers';
import NavMainSubMenuController from './lib/controllers/nav-main-sub-menu-controller';
import HeaderController from './lib/controllers/header-controller';
import SearchFieldController from './lib/controllers/search-field-controller';
import DisruptorController from './lib/controllers/disruptor-controller';
import KeyvisualController from './lib/controllers/keyvisual-controller';
import ChildPageNavigation from './lib/controllers/child-page-navigation-controller';
import SwiperController from './lib/controllers/swiper-controller';
import ShortFactController from './lib/controllers/short-fact-controller';
import ChartController from './lib/controllers/chart-controller';
import InfographicCirclesController from './lib/controllers/infographic-circles.js';
import InfographicDonutSvgController from './lib/controllers/infographic-donut-svg.js';

// Setup functions
import { SetupInViewDetection } from './lib/bootstrap/setup-in-view-detection';
import { SetupAnchorScrollTo } from './lib/bootstrap/setup-anchor-scroll-to';
import { SetupLightbox } from './lib/bootstrap/setup-lightbox';
import { SetupIsScrolledDetector } from './lib/bootstrap/setup-is-scrolled-detector';

gsap.defaults({
  ease: Power4.easeInOut,
  duration: 0.35
});

ready(function () {


  var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
  if (isIE11) document.body.classList.add("-is-ie-11");

  // Stimulus.js and controllers
  const application = Application.start();
  application.register('nav-main-sub-menu', NavMainSubMenuController);
  application.register('header', HeaderController);
  application.register('search-field', SearchFieldController);
  application.register('disruptor', DisruptorController);
  application.register('keyvisual', KeyvisualController);
  application.register('child-page-navigation', ChildPageNavigation);
  application.register('swiper', SwiperController);
  application.register('short-fact', ShortFactController);
  application.register('chart', ChartController);
  application.register('infographic-circles', InfographicCirclesController);
  application.register('infographic-donut-svg', InfographicDonutSvgController);

  registerGeneratedControllers(application);

  // Setup functions
  setTimeout(() => {
    // delay a bit until the app is ready
    SetupInViewDetection(application);
  }, 100)
  SetupAnchorScrollTo();
  SetupLightbox();
  SetupIsScrolledDetector();

});